<style lang="scss" scoped>
.complete-profile-modal::v-deep .v--modal-box {
  border-radius: 5px;
  overflow: visible;
  display: inline-block;
  width: 40% !important;
  transform: translateX(-50%);
  left: 50% !important;
  padding: 50px;
}
</style>

<template>
  <modal
    class="complete-profile-modal"
    name="complete-profile-modal"
    height="auto"
    :adaptive="true"
    :scrollable="true"
    :clickToClose="false"
  >
    <div class="row">
      <div class="col-12 text-primary">
        <p class="alert alert-info">
          Schön das du den Weg zu uns gefunden hast! Um dir bestmögliche
          Flirtchancen zu ermöglichen, benötigen wir noch kurz dein Alter und
          deinen Wohnort. Direkt danach kannst du auch schon loslegen!
        </p>
        <resource
          title="Ändern"
          resource="customerProfile"
          :attributes="attributes"
          :original="customerProfile"
          header-class="bg-primary"
          @resource-persisted="refresh()"
        >
          <div slot="title" class="text-light">
            Vervollständige dein Profil.
          </div>
        </resource>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  data() {
    return {
      attributes: []
    };
  },
  computed: {
    customerProfile() {
      if (Laravel.user && Laravel.user.customer_profile) {
        let profile = { ...Laravel.user.customer_profile };
        profile.update_url = profile.complete_url;
        return profile;
      }
      return null;
    }
  },
  created() {
    let showModal = false;
    if (Laravel.user) {
      if (!Laravel.user.customer_profile.zipcode) {
        this.attributes.push({
          name: "postcode",
          label: "PLZ",
          type: "PostcodeSelector"
        });
        showModal = true;
      }
      if (!Laravel.user.customer_profile.birthday) {
        this.attributes.push({
          name: "birthday",
          label: "Geburtsdatum",
          type: "BirthdaySelector",
          withRandomSelector: false,
          onlyDate: true
        });
        showModal = true;
      }
      if (showModal) {
        this.$nextTick(() => {
          this.$modal.show("complete-profile-modal");
        });
      }
    }
  },
  methods: {
    close() {
      this.$modal.hide("complete-profile-modal");
    },
    refresh() {
      location.reload();
    }
  }
};
</script>
